import { render, staticRenderFns } from "./StatusHistory.vue?vue&type=template&id=78518621&"
import script from "./StatusHistory.vue?vue&type=script&lang=ts&"
export * from "./StatusHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports